"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var DeviceSupport_1 = require("./DeviceSupport"),
    TutorialSlideType_1 = require("./TutorialSlideType"),
    TutorialResponse = function TutorialResponse(e) {
  this.slideTypes = [];

  for (var i = e.ppi, p = e.devicePixelRatio, t = 0, r = e.slides; t < r.length; t++) {
    var o = r[t];
    this.slideTypes.push(TutorialSlideType_1.TutorialSlideType[o]);
  }

  this.ppi = i, this.devicePixelRatio = p, e.deviceSupport && (this.deviceSupport = new DeviceSupport_1.DeviceSupport(e.deviceSupport));
};

exports.TutorialResponse = TutorialResponse;